import React, { useEffect, useState } from 'react';

import '../../../Styles/ICASTFeature.css';
import gallery01 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/01.jpg';
import gallery02 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/02.jpg';
import gallery03 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/03.jpg';
import gallery04 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/04.jpg';
import gallery05 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/05.jpg';
import gallery06 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/06.jpg';
import gallery07 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/07.jpg';
import gallery08 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/08.jpg';
import gallery09 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/09.jpg';
import gallery10 from '../../../Assets/Linkages/InternationalConferences/ICASEGallery/10.jpg';

const images = [
  gallery01, gallery02, gallery03, gallery04, gallery05,
  gallery06, gallery07, gallery08, gallery09, gallery10,
];

const getVisibleCount = () => {
  if (window.innerWidth < 650) return 1;
  if (window.innerWidth < 1050) return 2;
  return 4;
};

const ICASEGallery = () => {
  const [start, setStart] = useState(0);
  const [visible, setVisible] = useState(getVisibleCount);

  useEffect(() => {
    const resize = () => {
      setVisible(getVisibleCount());
      setStart(0);
    };
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setStart((current) => (current + visible) % images.length);
    }, 3000);
    return () => window.clearInterval(timer);
  }, [visible]);

  const shown = Array.from({ length: visible }, (_, index) => images[(start + index) % images.length]);

  return (
    <section className="icast-gallery-section" aria-labelledby="icase-gallery-title">
      <div className="icast-gallery-inner">
        <p className="section-eyebrow">MOMENTS FROM ICASE</p>
        <h2 id="icase-gallery-title">Gallery</h2>
        <div className="icase-title-line" aria-hidden="true" />
        <div className="icast-gallery-slider" aria-live="off">
          {shown.map((image, index) => (
            <figure className="icast-gallery-item" key={`${start}-${index}`}>
              <img src={image} alt={`ICASE conference moment ${((start + index) % images.length) + 1}`} loading="lazy" />
            </figure>
          ))}
        </div>
        <div className="icast-partners-controls">
          <button type="button" onClick={() => setStart((start - visible + images.length) % images.length)} aria-label="Previous ICASE gallery images">←</button>
          <span>{String(start + 1).padStart(2, '0')} / {images.length}</span>
          <button type="button" onClick={() => setStart((start + visible) % images.length)} aria-label="Next ICASE gallery images">→</button>
        </div>
      </div>
    </section>
  );
};

export default ICASEGallery;
